import { UploadSummaryController } from './file-upload-summary.controller';
import template from './file-upload-summary.html';

export const UploadSummaryComponent = {
  name: 'uploadSummary',
  restrict: 'E',
  template,
  controller: UploadSummaryController,
  controllerAs: 'vm',
  bindings: {
    files: '=',
    uploadFile: '&',
    onFileClick: '&',
    singleUpload: '<',
    multipleUpload: '<'
  }
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/summary/file-upload-summary.component.js